import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

import { UnifiedInboxConversation } from './useGetInboxConversations';

export type ApiRequest_SearchInboxConversations = {
  location_id?: Id;
  q?: string;
};

export type ApiResponse_SearchInboxConversations = UnifiedInboxConversation[];

const METHOD = 'GET';
const ENDPOINT = 'conversation/inbox/search';

export const QUERY_KEY = (params: ApiRequest_SearchInboxConversations) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useSearchInboxConversations = (
  params: ApiRequest_SearchInboxConversations,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: !!params.location_id && enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async (): Promise<UnifiedInboxConversation[]> => {
      const data = await handleApiCall<
        ApiResponse_SearchInboxConversations,
        ApiRequest_SearchInboxConversations
      >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), params);

      return data;
    },
  });
};
